import angular from "angular";

angular
    .module('app')
    .component('fieldForm', {
        template: require('./field-form.html'),
        controller: ['$http', 'notifier', '$timeout', '$uibModal', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, notifier, $timeout, $uibModal) {

    const $ctrl = this;

    $ctrl.$onInit = () => {
        $ctrl.field = $ctrl.resolve.field;

        $ctrl.title = $ctrl.field ? $ctrl.field.title : '';
        $ctrl.relatedTo = $ctrl.field ? $ctrl.field.related_to : null;
        $ctrl.type = $ctrl.field ? $ctrl.field.type : null;
        $ctrl.options = $ctrl.field && $ctrl.field.type === 'options'
            ? $ctrl.field.options.split(';').map(v => { return {value: v}} )
            : [{value: ''}];
        $ctrl.number = $ctrl.field ? $ctrl.field.number : '';
    };

    $ctrl.addOption = () => {
        $ctrl.options.push({value: ''});
    };

    $ctrl.delOption = (ind) => {
        $ctrl.options.splice(ind, 1);
    }

    $ctrl.submit = () => {

        const params = {
            title: $ctrl.title,
            related_to: $ctrl.relatedTo,
            type: $ctrl.type,
            options: $ctrl.type === 'options' ? $ctrl.options.map(v => v.value).join(';') : null,
            number: $ctrl.number,
        };

        const url = $ctrl.field ? `/control-panel/fields/${$ctrl.field.id}` : '/control-panel/fields';

        $http
            .post(url, params)
            .then(
                res => {
                    params.id = res.data.id;

                    if ($ctrl.field) {
                        notifier.successNotify('Данные успешно обновились', 2000);
                    } else {
                        notifier.successNotify('Данные успешно сохранились', 2000);
                    }

                    $ctrl.close({$value: params});
                },
                err => {
                    notifier.errorResponseNotify(err);
                }
            );
    }

}


// WEBPACK FOOTER //
// ./resources/assets/modules/components/field-form/field-form.js